export enum AptBroadBandType {
    BroadBand = 'BROADBAND',
}
